/* i18n: strings come from window.jabT (snippets/jab-i18n.liquid) */
var jT = window.jabTr || (window.jabTr = function (k, d, n) { var s = (window.jabT && window.jabT[k]) || d; return n != null ? s.replace('[n]', n) : s; });
/* ============================================================
   Jabree Side Cart (jab-cart.js)
   Self-contained drawer on the Shopify Cart AJAX API + variant modal.
   Config from #jab-cart-config, upsell data from #jab-upsell-data.
   ============================================================ */
(function () {
  'use strict';

  // capture native fetch BEFORE we monkeypatch window.fetch, so our own
  // cart calls never re-trigger the theme-add interceptor (no double work).
  var nativeFetch = (window.fetch ? window.fetch.bind(window) : null);

  var cfg = {}, UPSELL = {};
  try { cfg = JSON.parse(document.getElementById('jab-cart-config').textContent); } catch (e) {}
  /* A single bad value here nukes every upsell card: openModal() bails on
     `if (!mData) return`, so the whole "Add to your order" row goes dead with no
     error anywhere. That is exactly what happened 2026-08-12 — a variant with no
     image made Liquid emit the literal text "Liquid error..." where a URL belonged
     and this parse threw. Never swallow it silently again. */
  try { UPSELL = JSON.parse(document.getElementById('jab-upsell-data').textContent); }
  catch (e) { UPSELL = {}; try { console.error('[jab-cart] #jab-upsell-data is not valid JSON — upsell cards will not open.', e); } catch (e2) {} }

  var root, overlay, panel, els = {}, lastCart = null, gwpBusy = false;
  var accelEl = null, accelHTML = null;

  /* window.jabMoneyParts is market-aware (layout/theme.liquid); cfg.moneySymbol
     is only the fallback now. */
  /* Zero-decimal currencies (yen, won...) have no cents: whole units only. */
  function zeroDec() { try { return /^(JPY|KRW|VND|CLP|ISK|PYG|UGX|XAF|XOF|RWF)$/.test((window.Shopify && Shopify.currency && Shopify.currency.active) || ''); } catch (e) { return false; } }
  function money(c) {
    var p = window.jabMoneyParts || { pre: cfg.moneySymbol || '$', post: '' };
    var s = zeroDec() ? String(Math.round((c || 0) / 100)) : ((c || 0) / 100).toFixed(2);
    var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return p.pre + parts.join('.') + p.post;
  }
  function q(s) { return panel.querySelector(s); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- cart api (native fetch → no interceptor echo) ---------- */
  function getCart() { return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    return nativeFetch('/cart/change.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function addVariant(id, qty, props) {
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return nativeFetch('/cart/add.js', { method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }) }).then(function (r) { return r.json(); });
  }

  /* ---------- native Fabric drawer neutralizer ---------- */
  function killNative() {
    try {
      document.querySelectorAll('cart-drawer-component').forEach(function (c) { c.removeAttribute('auto-open'); });
      document.querySelectorAll('cart-drawer-component dialog[open]').forEach(function (d) { try { d.close(); } catch (e) {} });
    } catch (e) {}
  }

  /* ---------- open / close ---------- */
  function open() { if (!root) return; killNative(); overlay.classList.add('is-open'); panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; refresh(); reinitAccel(); }
  // Shopify's accelerated-checkout web component locks in its layout (inline row vs vertical
  // stack) the first time it initializes. If the drawer is hidden at page load it inits as a
  // stack and never re-lays-out when opened from the cart icon (only the add-to-cart path,
  // which fires a cart-change re-render while visible, looked right). Re-inserting the pristine
  // markup on each open forces it to re-initialize while the drawer is visible -> inline row.
  function reinitAccel() {
    if (!accelEl || accelHTML == null) return;
    try {
      accelEl.innerHTML = accelHTML;
      requestAnimationFrame(function () { try { window.dispatchEvent(new Event('resize')); } catch (e) {} });
    } catch (e) {}
  }
  function close() { overlay.classList.remove('is-open'); panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  /* ---------- render ---------- */
  function refresh() { return getCart().then(render); }
  function render(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    maybeHandleGwp(cart);
    renderItems(cart); renderShipping(cart); renderBuy2(cart); renderKit(cart); renderBeltTiers(cart); renderGapFill(cart); renderUpsells(cart); renderFooter(cart); syncThemeBubble(cart);
    renderCollective(cart);
  }
  /* Never upsell the Collective to someone who already has it in the cart. */
  function renderCollective(cart) {
    if (!root) return;
    var inCart = false;
    cart.items.forEach(function (it) { if (it.handle === 'jab-collective') inCart = true; });
    root.classList.toggle('is-jc-in', inCart);
  }
  function isGift(it) { return it.properties && (it.properties._gift === 'true' || it.properties._gift === true); }
  function giftlessSubtotal(cart) { var s = 0; cart.items.forEach(function (it) { if (!isGift(it)) s += it.final_line_price; }); return s; }

  function renderItems(cart) {
    var wrap = els.items;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="jab-cart__empty">' + esc(jT('cart_empty','Your cart is empty.')) + '<br><br><a href="' + esc(cfg.emptyLink || '/collections/all') + '">' + esc(jT('continue_shopping','Continue shopping')) + '</a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      var imgTag = img ? '<img class="jab-line__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<div class="jab-line__img"></div>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="jab-line__variant">' + esc(it.variant_title) + '</p>' : '';
      if (isGift(it)) {
        html += '<div class="jab-line jab-line--gift">' + imgTag + '<div class="jab-line__main">' +
          '<span class="jab-gift-tag">★ FREE GIFT</span><p class="jab-line__title">' + esc(it.product_title) + '</p>' +
          '<p class="jab-line__giftnote">Added to your order</p></div>' +
          '<span class="jab-line__price">' + (it.final_line_price === 0 ? 'FREE' : money(it.final_line_price)) + '</span></div>';
        return;
      }
      var priceHtml = (it.original_line_price > it.final_line_price)
        ? '<del>' + money(it.original_line_price) + '</del>' + money(it.final_line_price) : money(it.final_line_price);
      html += '<div class="jab-line">' + imgTag + '<div class="jab-line__main">' +
        '<p class="jab-line__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' + variant +
        '<div class="jab-line__bottom"><div class="jab-qty">' +
          '<button data-act="dec" data-key="' + esc(it.key) + '" aria-label="Decrease">&minus;</button>' +
          '<span class="jab-qty__n">' + it.quantity + '</span>' +
          '<button data-act="inc" data-key="' + esc(it.key) + '" aria-label="Increase">+</button></div>' +
        '<span class="jab-line__price">' + priceHtml + '</span></div></div>' +
        '<button class="jab-line__remove" data-act="remove" data-key="' + esc(it.key) + '" aria-label="Remove">&times;</button></div>';
    });
    wrap.innerHTML = html;
  }

  function renderShipping(cart) {
    var box = els.ship;
    var track = box ? box.querySelector('.jab-ship__track') : null;
    // Free international shipping countries get a real progress bar, converted from the
    // USD minimum at Shopify's rate (the same rate the discount minimum uses).
    // Japan: a cart made only of the free-shipping Jabshell pieces ships free.
    if (cfg.intl && cfg.intl.jpIds && cfg.intl.jpIds.length && cart.items && cart.items.length &&
        cart.items.every(function (it) { return cfg.intl.jpIds.indexOf(it.product_id) > -1; })) {
      box.style.display = '';
      box.classList.remove('is-intl');
      if (track) track.style.display = '';
      box.classList.add('is-unlocked');
      els.shipMsg.innerHTML = cfg.intl.jpText || cfg.freeShip.successText || "You've unlocked free shipping!";
      els.shipFill.style.width = '100%';
      return;
    }
    if (cfg.intl && cfg.intl.fs) {
      var rate = 1;
      try { rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) {}
      var fsT = Math.ceil(cfg.intl.fs * rate / 100) * 100, fsSub = giftlessSubtotal(cart);
      var fsLeft = Math.max(0, fsT - fsSub), fsDone = fsLeft <= 0;
      var short = function (c) { return money(c).replace(/[.,]00(?=\D*$)/, ''); };
      document.querySelectorAll('#jab-cart-root [data-jab-fs-min]').forEach(function (el) { el.textContent = short(fsT); });
      box.style.display = '';
      box.classList.remove('is-intl');
      if (track) track.style.display = '';
      box.classList.toggle('is-unlocked', fsDone);
      els.shipMsg.innerHTML = fsDone ? (cfg.freeShip.successText || "You've unlocked free shipping!")
        : "You're <strong>" + short(fsLeft) + '</strong> away from free shipping!';
      els.shipFill.style.width = Math.min(100, Math.round(fsSub / fsT * 100)) + '%';
      return;
    }
    // Outside the US there is no free-shipping threshold, so show the flat international
    // rate (or "calculated at checkout" for CA/MX) instead of a progress bar to nowhere.
    if (cfg.intl && cfg.intl.mode && cfg.intl.mode !== 'free') {
      if (!cfg.intl.text) { box.style.display = 'none'; return; }
      box.style.display = '';
      box.classList.add('is-intl');
      box.classList.remove('is-unlocked');
      if (track) track.style.display = 'none';
      els.shipMsg.innerHTML = cfg.intl.text || '';
      return;
    }
    if (track) track.style.display = '';
    box.classList.remove('is-intl');
    if (!cfg.freeShip || !cfg.freeShip.enabled || !cfg.freeShip.threshold) { box.style.display = 'none'; return; }
    box.style.display = '';
    var threshold = cfg.freeShip.threshold, subtotal = giftlessSubtotal(cart);
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100)), remaining = Math.max(0, threshold - subtotal), unlocked = remaining <= 0;
    var msg = unlocked ? (cfg.freeShip.successText || "You've unlocked free shipping!")
      : (cfg.freeShip.progressText || "You're {{amount}} away from free shipping!").replace('{{amount}}', '<strong>' + money(remaining) + '</strong>');
    box.classList.toggle('is-unlocked', unlocked); els.shipMsg.innerHTML = msg; els.shipFill.style.width = pct + '%';
  }

  /* International buy-2 nudge: the "Boardshort Bundle" automatic discount takes 20% off a
     second K59. Opens the shared variant modal so any available size/colour can be picked. */
  function renderBuy2(cart) {
    var el = els.b2; if (!el) return;
    var qty = 0, unit = 0;
    cart.items.forEach(function (it) {
      if (isGift(it) || it.handle !== 'k59-boardshort') return;
      qty += it.quantity;
      if (!unit) unit = it.final_price;
    });
    var show = qty === 1;
    el.hidden = !show;
    if (!show) return;
    if (els.b2Sub) {
      els.b2Sub.textContent = 'Any size or colour, save ' + money(Math.round(unit * 0.2)) + ' at checkout';
    }
  }

  /* Jabshell kit: one piece in the cart -> offer the other at $40 off (automatic BXGY
     discount). The saving is in shop currency, so convert it for the shopper's currency. */
  var kitCtx = null;
  function renderKit(cart) {
    var el = els.kit, k = cfg.kit;
    if (!el) return;
    kitCtx = null;
    if (!k) { el.hidden = true; return; }
    var lineA = null, lineB = null;
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      if (it.product_id == k.a && !lineA) lineA = it;
      if (it.product_id == k.b && !lineB) lineB = it;
    });
    var have = lineA || lineB;
    var otherId = lineA ? k.b : k.a;
    var data = UPSELL[otherId];
    if (!have || (lineA && lineB) || !data) { el.hidden = true; return; }
    var rate = 1;
    try { rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) {}
    var save = zeroDec() ? Math.round(k.save * rate / 100) * 100 : Math.round(k.save * rate);
    var name = lineA ? k.bName : k.aName;
    var props = { _bundle: 'kit' };
    if (have.properties && have.properties['Pre-order']) props['Pre-order'] = have.properties['Pre-order'];
    kitCtx = { pid: otherId, save: save, props: props, pre: have.options_with_values || [] };
    el.hidden = false;
    if (els.kitHead) els.kitHead.textContent = 'Add the ' + name + ', save ' + money(save).replace(/[.,]00(?=\D*$)/, '');
    if (els.kitSub) els.kitSub.innerHTML = 'Complete the Jabshell kit. <s>' + money(data.price) + '</s><b>' + money(Math.max(0, data.price - save)) + '</b>';
  }

  /* Belt multi-buy tiers (2 for $55, 3 for $75). The tiers are Shopify automatic ORDER
     discounts, so they are invisible until checkout unless the drawer says so. Nudge to
     the next rung, then confirm and stop: there is no fourth tier to sell into. */
  function renderBeltTiers(cart) {
    var el = els.bt, bt = cfg.beltTiers;
    if (!el) return;
    if (!bt || !bt.enabled || !bt.ids || !bt.ids.length) { el.hidden = true; return; }
    var ids = {};
    bt.ids.forEach(function (id) { ids[id] = true; });
    var qty = 0;
    cart.items.forEach(function (it) { if (!isGift(it) && ids[it.product_id]) qty += it.quantity; });
    if (qty < 1) { el.hidden = true; return; }

    var tiers = bt.tiers || [];
    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (qty < tiers[i].qty) { next = tiers[i]; break; } }

    el.hidden = false;
    if (next) {
      el.classList.remove('is-done');
      if (els.btHead) els.btHead.textContent = next.head || '';
      if (els.btSub) els.btSub.textContent = next.sub || '';
      if (els.btBtn) { els.btBtn.hidden = false; els.btBtn.setAttribute('href', bt.url || '/collections/all'); }
    } else {
      /* At or above the top rung: confirm the tier and stop nudging. */
      el.classList.add('is-done');
      if (els.btHead) els.btHead.textContent = bt.doneHead || '';
      if (els.btSub) els.btSub.textContent = bt.doneSub || '';
      if (els.btBtn) els.btBtn.hidden = true;
    }
  }

  /* Free-shipping gap filler.
     The progress bar already tells people how far they are from free shipping; what it
     cannot do is close the gap. So when the gap is one item away we name a specific
     item instead of leaving them to hunt for one. Which item is decided per cart by
     pickGapProduct below, not fixed in the theme.
     Deliberately silent when the belt-tier nudge is already up: two nudges stacked
     read as pestering, and that one is already selling a second item. */
  /* Which product to name in the gap card. The old version always said "any belt",
     which is wrong copy on a boardshort cart: nobody wears a belt with a boardshort
     (TJ, 2026-09-03). So the pick is driven by the SAME pairs map the upsell ranking
     uses — K59 pulls a tee, denim still pulls a belt — and only falls back to the
     cheapest gap-closer when the cart has no pairing to go on (e.g. a lone hat). */
  var RANK = null, rankRead = false;
  function rankCfg() {
    if (!rankRead) {
      rankRead = true;
      try { RANK = JSON.parse(document.getElementById('jab-upsell-rank-config').textContent); } catch (e) { RANK = null; }
    }
    return RANK;
  }
  function pickGapProduct(cart, remaining) {
    var cands = (cfg.gapFill && cfg.gapFill.candidates) || [];
    if (!cands.length) return null;
    var inCart = {};
    cart.items.forEach(function (it) { if (!isGift(it)) inCart[it.handle] = true; });
    var byHandle = {};
    cands.forEach(function (c) { byHandle[c.handle] = c; });

    /* Affinity first, in the order the pairs map lists them. */
    var rk = rankCfg(), pairs = (rk && rk.pairs) || {}, order = [];
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      (pairs[it.handle] || []).forEach(function (h) {
        if (!inCart[h] && order.indexOf(h) < 0) order.push(h);
      });
    });
    var paired = [];
    order.forEach(function (h) {
      var c = byHandle[h];
      if (c && c.price >= remaining) paired.push(c);
    });
    if (paired.length) {
      /* Walk the pairs order, which is merchandising intent (K59 lists tees before
         hats and hoodies). But denim leads several lists at $85, and asking someone
         to add $85 to save $7 of shipping is not a nudge, it is a wall — so skip
         anything priced far above the cheapest paired option that also clears. */
      var cheapest = paired[0];
      paired.forEach(function (c) { if (c.price < cheapest.price) cheapest = c; });
      var cap = cheapest.price * 1.5;
      for (var i = 0; i < paired.length; i++) if (paired[i].price <= cap) return paired[i];
      return cheapest;
    }
    /* Nothing paired clears it: cheapest thing that does, so the ask stays small. */
    var best = null;
    cands.forEach(function (c) {
      if (inCart[c.handle] || c.price < remaining) return;
      if (!best || c.price < best.price) best = c;
    });
    return best;
  }
  function renderGapFill(cart) {
    var el = els.gap, g = cfg.gapFill;
    if (!el) return;
    var hide = function () { el.hidden = true; };
    if (!g || !g.enabled || !g.candidates || !g.candidates.length) return hide();
    /* No US free-shipping threshold outside the US, so there is no gap to close. */
    if (cfg.intl && cfg.intl.mode && cfg.intl.mode !== 'free') return hide();
    if (!cfg.freeShip || !cfg.freeShip.enabled || !cfg.freeShip.threshold) return hide();
    if (els.bt && !els.bt.hidden) return hide();

    var remaining = cfg.freeShip.threshold - giftlessSubtotal(cart);
    if (remaining <= 0 || remaining > (g.maxGap || 0)) return hide();

    var pick = pickGapProduct(cart, remaining);
    if (!pick) return hide();

    el.hidden = false;
    if (els.gapHead) els.gapHead.textContent = (g.headPre || '') + money(remaining) + (g.headPost || '');
    if (els.gapSub) els.gapSub.textContent = (g.subPre || '') + pick.title + (g.subMid || '') + money(pick.price) + (g.subPost || '');
    if (els.gapBtn) {
      els.gapBtn.textContent = pick.cta || g.cta || jT('add_one','Add one');
      els.gapBtn.setAttribute('data-pid', pick.id);
    }
  }

  function renderUpsells(cart) {
    var box = els.up; if (!box) return;
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var shown = 0, max = (cfg.upsell && cfg.upsell.max) || 6;
    box.querySelectorAll('.jab-up__card').forEach(function (card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      /* the kit card above already offers this product at $40 off */
      var hide = inCart[pid] || (kitCtx && kitCtx.pid == pid) || shown >= max; card.style.display = hide ? 'none' : ''; if (!hide) shown++;
    });
    box.classList.toggle('is-empty', shown === 0);
  }

  function renderFooter(cart) {
    var empty = !cart.items.length;
    els.foot.classList.toggle('jab-cart__foot--empty', empty);
    els.count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!empty) els.checkout.innerHTML = esc(jT('checkout','Checkout')) + ' <span class="dot">•</span> ' + money(cart.total_price);
    else els.checkout.textContent = jT('checkout','Checkout');
    var code = cfg.discountCode || '';
    els.checkout.setAttribute('href', code ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/checkout');
  }

  function syncThemeBubble(cart) {
    var n = (cart && cart.item_count) || 0;

    document.querySelectorAll('[data-testid="cart-bubble"]').forEach(function (el) {
      el.textContent = n ? String(n) : '';
      /* Fabric hides the NUMBER with .hidden on the count span, separately from the wrapper.
         Leaving it on is why the count stayed blank until a reload, and why cart-icon's
         :has(.cart-bubble__text-count:empty) rule shrank the bubble to a bare 10px dot. */
      el.classList.toggle('hidden', n === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', n === 0);
    });

    /* <cart-icon> owns state we must not fake: the --has-cart class masks a donut-shaped hole
       out of the cart SVG behind the bubble, and it caches the count in sessionStorage for
       bfcache restores. It only ever hears the theme's own cartUpdate event, which we never
       fire, so drive its renderer directly and fall back to the class if it has not upgraded. */
    document.querySelectorAll('cart-icon').forEach(function (el) {
      if (typeof el.renderCartBubble === 'function') {
        try { el.renderCartBubble(n, false, false); return; } catch (e) {}
      }
      el.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });

    /* keep the aria-live count honest; format is "<translated label>: <count>" */
    document.querySelectorAll('#cart-bubble-text .visually-hidden').forEach(function (el) {
      if (/:\s*\d+\s*$/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/:\s*\d+\s*$/, ': ' + n);
      }
    });
  }

  /* ---------- gift with purchase ---------- */
  function maybeHandleGwp(cart) {
    if (!cfg.gwp || !cfg.gwp.enabled || !cfg.gwp.variantId || !cfg.gwp.threshold || gwpBusy) return;
    var subtotal = giftlessSubtotal(cart);
    var giftLine = cart.items.filter(function (it) { return isGift(it) && it.variant_id == cfg.gwp.variantId; })[0];
    var qualifies = subtotal >= cfg.gwp.threshold;
    if (qualifies && !giftLine && cart.items.length) {
      gwpBusy = true; addVariant(cfg.gwp.variantId, 1, { _gift: 'true' }).then(getCart).then(function (c) { gwpBusy = false; render(c); }, function () { gwpBusy = false; });
    } else if (!qualifies && giftLine) {
      gwpBusy = true; changeLine(giftLine.key, 0).then(function (c) { gwpBusy = false; render(c); }, function () { gwpBusy = false; });
    }
  }

  /* ---------- line item interactions (optimistic + 1 round trip) ---------- */
  function onItemsClick(e) {
    var btn = e.target.closest('[data-act]'); if (!btn) return;
    var key = btn.getAttribute('data-key'), act = btn.getAttribute('data-act');
    if (!lastCart) return;
    var item = lastCart.items.filter(function (i) { return i.key === key; })[0]; if (!item && act !== 'remove') return;
    var next = act === 'inc' ? item.quantity + 1 : act === 'dec' ? item.quantity - 1 : 0;
    // optimistic update
    if (next <= 0) { lastCart.items = lastCart.items.filter(function (i) { return i.key !== key; }); }
    else { item.quantity = next; item.final_line_price = item.final_price * next; item.original_line_price = (item.original_price || item.final_price) * next; }
    lastCart.item_count = lastCart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    renderItems(lastCart); renderShipping(lastCart); renderFooter(lastCart); syncThemeBubble(lastCart);
    // authoritative (render straight from response, no 2nd fetch)
    changeLine(key, next).then(render).catch(refresh);
  }

  /* ================= variant modal ================= */
  var mEl = {}, mData = null, mSel = [], mImgs = [], mSlide = -1, mCtx = null;
  function colorIdx(opts) { for (var i = 0; i < opts.length; i++) { var n = opts[i].toLowerCase(); if (n.indexOf('color') >= 0 || n.indexOf('colour') >= 0) return i; } return -1; }

  /* ctx (optional, kit offer): { save: cents off, props: line properties, pre: [{name,value}] to preselect } */
  function openModal(pid, ctx) {
    mData = UPSELL[pid]; if (!mData) return;
    mCtx = ctx || null;
    mSel = mData.options.map(function () { return null; });
    if (mCtx && mCtx.pre) {
      mData.options.forEach(function (n, oi) {
        mCtx.pre.forEach(function (p) { if (p.name === n && valOk(oi, p.value)) mSel[oi] = p.value; });
      });
    }
    mSlide = -1;
    mImgs = (mData.images && mData.images.length) ? mData.images.slice() : [];
    // slider
    mEl.track.innerHTML = mImgs.map(function (src) { return '<img class="jab-modal__slide" src="' + esc(src) + '" alt="" draggable="false">'; }).join('');
    mEl.dots.innerHTML = mImgs.map(function (_, i) { return '<span class="jab-dot' + (i === 0 ? ' is-on' : '') + '"></span>'; }).join('');
    mEl.title.textContent = mData.title;
    buildOpts();
    updateModal();
    mEl.root.classList.add('is-open'); mEl.root.setAttribute('aria-hidden', 'false');
  }
  function closeModal() { mEl.root.classList.remove('is-open'); mEl.root.setAttribute('aria-hidden', 'true'); }

  /* Only surface option values that still have stock somewhere. Previously this
     listed every value ever created and leaned on valOk() to grey the dead ones
     out, so a product down to its last size rendered a row of disabled chips and
     read as picked-over. Cross-option combos can still be invalid (e.g. Sand
     exists, M exists, Sand/M does not) — valOk() still disables those. */
  function uniqVals(oi) { var seen = {}, out = []; mData.variants.forEach(function (v) { if (!v.available) return; var val = v['o' + (oi + 1)]; if (val != null && !seen[val]) { seen[val] = 1; out.push(val); } }); return out; }
  // is a value for option oi selectable given current selections on the OTHER options?
  function valOk(oi, val) {
    return mData.variants.some(function (v) {
      if (!v.available) return false;
      if (v['o' + (oi + 1)] !== val) return false;
      for (var j = 0; j < mSel.length; j++) { if (j !== oi && mSel[j] != null && v['o' + (j + 1)] !== mSel[j]) return false; }
      return true;
    });
  }
  function swatchImg(oi, val) { var v = mData.variants.filter(function (x) { return x['o' + (oi + 1)] === val && x.img; })[0]; return v ? v.img : (mImgs[0] || ''); }

  function buildOpts() {
    var ci = colorIdx(mData.options), html = '';
    mData.options.forEach(function (name, oi) {
      html += '<div class="jab-opt" data-oi="' + oi + '"><div class="jab-opt__label">' + esc(name) + '</div><div class="jab-opt__row">';
      uniqVals(oi).forEach(function (val) {
        if (oi === ci) {
          html += '<button type="button" class="jab-chip jab-chip--swatch" data-oi="' + oi + '" data-val="' + esc(val) + '"><img src="' + esc(swatchImg(oi, val)) + '" alt=""><span>' + esc(val) + '</span></button>';
        } else {
          html += '<button type="button" class="jab-chip" data-oi="' + oi + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }
      });
      html += '</div></div>';
    });
    mEl.opts.innerHTML = html;
  }

  function resolveVariant() {
    if (mSel.some(function (s) { return s == null; })) return null;
    return mData.variants.filter(function (v) {
      for (var j = 0; j < mSel.length; j++) { if (v['o' + (j + 1)] !== mSel[j]) return false; } return true;
    })[0] || null;
  }

  /* Move the photo the moment a COLOUR is picked.

     This used to live inside updateModal's `v && v.available` branch, so it only
     fired once a FULL variant resolved. On a two-option product — the belts are
     Colour x Length — clicking a colour changed nothing until a length was also
     chosen, which reads as a broken swatch rather than a product with two
     options still to pick. Every variant of a colour shares that colour's image
     (verified across all three belts), so the colour alone is enough to know
     which slide to show.

     Prefers a variant matching the OTHER selections too, so once a length is
     chosen the slide still tracks the colour. `mSlide` stops a re-render from
     yanking the slider back while the customer is swiping the gallery by hand. */
  function syncColorSlide() {
    var ci = colorIdx(mData.options);
    if (ci < 0 || mSel[ci] == null) return;
    function pick(strict) {
      return mData.variants.filter(function (v) {
        if (v['o' + (ci + 1)] !== mSel[ci] || !v.img) return false;
        if (!strict) return true;
        for (var j = 0; j < mSel.length; j++) {
          if (j !== ci && mSel[j] != null && v['o' + (j + 1)] !== mSel[j]) return false;
        }
        return true;
      })[0];
    }
    var hit = pick(true) || pick(false);
    if (!hit) return;
    var idx = mImgs.indexOf(hit.img);
    if (idx < 0 || idx === mSlide) return;
    mSlide = idx;
    scrollSlide(idx);
  }

  function updateModal() {
    // chip states
    mEl.opts.querySelectorAll('.jab-chip').forEach(function (chip) {
      var oi = +chip.getAttribute('data-oi'), val = chip.getAttribute('data-val');
      chip.classList.toggle('is-active', mSel[oi] === val);
      chip.classList.toggle('is-disabled', !valOk(oi, val));
    });
    syncColorSlide();
    var v = resolveVariant();
    if (v && v.available) {
      var off = (mCtx && mCtx.save) ? Math.min(mCtx.save, v.price) : 0;
      mEl.add.disabled = false; mEl.add.innerHTML = esc(jT('add_to_cart','Add to cart')) + ' <span class="dot">•</span> ' + money(v.price - off);
      mEl.price.innerHTML = off ? '<del>' + money(v.price) + '</del> ' + money(v.price - off)
        : (mData.compare > v.price ? '<del>' + money(mData.compare) + '</del> ' : '') + money(v.price);
      mEl.note.textContent = '';
    } else {
      mEl.add.disabled = true; mEl.add.textContent = mSel.some(function (s) { return s == null; }) ? jT('select_options','Select options') : jT('unavailable','Unavailable');
      mEl.price.innerHTML = '';
      mEl.note.textContent = mData.options.map(function (n, i) { return mSel[i] == null ? n : null; }).filter(Boolean).map(function (n) { return 'Choose ' + n.toLowerCase(); }).join(' · ');
    }
  }

  /* Instant, NOT smooth. The slider is `scroll-snap-type: x mandatory`, and Chrome
     cancels a programmatic SMOOTH scroll by re-snapping it to the nearest snap
     point almost immediately: the gallery would creep a few hundred pixels and
     stall between two slides (measured on the Logo Belt drawer modal — stuck at
     scrollLeft 2000 on a 440px slide pitch, showing two half images). Assigning
     the position outright lands exactly on the snap point every time. */
  function scrollSlide(i) { var w = mEl.slider.clientWidth; mEl.slider.scrollTo({ left: w * i, behavior: 'auto' }); }

  function bindModal() {
    mEl.root.addEventListener('click', function (e) { if (e.target === mEl.root) closeModal(); });
    mEl.x.addEventListener('click', closeModal);
    /* Chips listen on BOTH click and pointerup. On real pointer input something
       upstream cancels the pointer sequence — `pointerdown` fires and then no
       `mousedown`/`click` ever arrives, so the chips felt dead to customers while
       chip.click() from the console worked. pointerup is the earliest event that
       still lands. The (chip, timestamp) guard swallows the duplicate when both
       events do fire, while still allowing rapid taps on DIFFERENT chips. */
    var lastChip = null, lastChipTs = 0;
    function pickChip(chip) {
      if (!chip || chip.classList.contains('is-disabled')) return;
      var now = Date.now();
      if (chip === lastChip && now - lastChipTs < 400) return;
      lastChip = chip; lastChipTs = now;
      var oi = +chip.getAttribute('data-oi'); mSel[oi] = chip.getAttribute('data-val'); updateModal();
    }
    mEl.opts.addEventListener('click', function (e) { pickChip(e.target.closest('.jab-chip')); });
    mEl.opts.addEventListener('pointerup', function (e) { pickChip(e.target.closest('.jab-chip')); });
    mEl.add.addEventListener('click', function () {
      var v = resolveVariant(); if (!v) return;
      mEl.add.disabled = true; mEl.add.textContent = 'Adding…';
      addVariant(v.id, 1, mCtx && mCtx.props).then(getCart).then(function (c) { closeModal(); render(c); }).catch(function () { mEl.add.disabled = false; updateModal(); });
    });
    mEl.slider.addEventListener('scroll', function () {
      var i = Math.round(mEl.slider.scrollLeft / mEl.slider.clientWidth);
      mEl.dots.querySelectorAll('.jab-dot').forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
    }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mEl.root.classList.contains('is-open')) closeModal(); });
  }

  /* ---------- events ---------- */
  function bind() {
    overlay.addEventListener('click', close);
    q('.jab-cart__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open') && !mEl.root.classList.contains('is-open')) close(); });
    els.items.addEventListener('click', onItemsClick);
    if (els.gap) {
      els.gap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jab-gap-add]'); if (!btn) return;
        var pid = btn.getAttribute('data-pid'); if (!pid) return;
        openModal(pid);
      });
    }
    if (els.kit) {
      els.kit.addEventListener('click', function (e) {
        if (!e.target.closest('[data-jab-kit-add]') || !kitCtx) return;
        openModal(kitCtx.pid, kitCtx);
      });
    }
    if (els.b2) {
      els.b2.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jab-b2-add]'); if (!btn) return;
        var pid = btn.getAttribute('data-pid'); if (!pid) return;
        openModal(pid);
      });
    }
    if (els.up) {
      els.up.addEventListener('click', function (e) {
        var card = e.target.closest('.jab-up__card'); if (!card) return;
        var pid = card.getAttribute('data-choose');
        if (pid) { openModal(pid); return; }
        var vid = card.getAttribute('data-variant-id'); if (!vid || card.classList.contains('is-busy')) return;
        var act = card.querySelector('.jab-up__action'); var lbl = act ? act.textContent : '';
        card.classList.add('is-busy'); if (act) act.textContent = 'Adding…';
        addVariant(vid, 1).then(getCart).then(function (c) { card.classList.remove('is-busy'); if (act) act.textContent = lbl; render(c); }).catch(function () { card.classList.remove('is-busy'); if (act) act.textContent = lbl; });
      });
      els.up.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.jab-up__card'); if (!card) return;
        e.preventDefault(); card.click();
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-testid="cart-drawer-trigger"], [data-testid="cart-icon"], a[href="/cart"], a[href$="/cart"]');
      if (!t) return; e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); open();
    }, true);
  }

  /* ---------- intercept theme add-to-cart (external calls only) ---------- */
  function hookFetch() {
    if (window.__jabFetchHooked || !window.fetch) return; window.__jabFetchHooked = true;
    var orig = window.fetch;
    window.fetch = function () {
      var p = orig.apply(this, arguments);
      try {
        var a0 = arguments[0], url = (typeof a0 === 'string' ? a0 : (a0 && a0.url)) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          var isAdd = /\/cart\/add/.test(url);
          p.then(function (r) { if (!r || r.ok === false) return; setTimeout(function () { killNative(); refresh(); if (isAdd && !gwpBusy) open(); }, 60); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- init ---------- */
  function init() {
    root = document.getElementById('jab-cart-root'); if (!root) return;
    overlay = root.querySelector('.jab-cart-overlay'); panel = root.querySelector('.jab-cart');
    accelEl = panel.querySelector('.jab-cart__accel'); if (accelEl) accelHTML = accelEl.innerHTML;
    els = { items: q('.jab-cart__items'), ship: q('.jab-ship'), shipMsg: q('.jab-ship__msg'), shipFill: q('.jab-ship__fill'),
      up: q('.jab-up'), foot: q('.jab-cart__foot'), count: q('[data-jab-count]'), checkout: q('.jab-cart__checkout'),
      b2: q('[data-jab-b2]'), b2Sub: q('[data-jab-b2-sub]'),
      kit: q('[data-jab-kit]'), kitHead: q('[data-jab-kit-head]'), kitSub: q('[data-jab-kit-sub]'),
      bt: q('[data-jab-bt]'), btHead: q('[data-jab-bt-head]'), btSub: q('[data-jab-bt-sub]'), btBtn: q('[data-jab-bt-btn]'),
      gap: q('[data-jab-gap]'), gapHead: q('[data-jab-gap-head]'), gapSub: q('[data-jab-gap-sub]'), gapBtn: q('[data-jab-gap-add]') };
    var mr = document.getElementById('jab-modal-root');
    mEl = { root: mr, x: mr.querySelector('.jab-modal__x'), slider: mr.querySelector('.jab-modal__slider'), track: mr.querySelector('.jab-modal__track'),
      dots: mr.querySelector('.jab-modal__dots'), title: mr.querySelector('.jab-modal__title'), price: mr.querySelector('.jab-modal__price'),
      opts: mr.querySelector('.jab-modal__opts'), add: mr.querySelector('.jab-modal__add'), note: mr.querySelector('.jab-modal__note') };
    bind(); bindModal(); hookFetch(); killNative(); refresh();
    window.JabCart = { open: open, close: close, refresh: refresh, openModal: openModal };
    // if we were bounced off the /cart page, open the drawer instead
    try { if (sessionStorage.getItem('jabOpenCart')) { sessionStorage.removeItem('jabOpenCart'); open(); } } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* yen formatting: 2026-10-27 */
